import Container from "./ui/Container";
import { PrimaryButton } from "./ui/Buttons";
import { useNavigate } from "react-router-dom";

export default function CTA() {
    const navigate = useNavigate();
    return (
        <section className="py-16 bg-blue-600 text-white">
            <Container>
                <div className="flex items-center justify-between">
                    <div>
                        <h2 className="text-3xl font-bold mb-2">Ready to Get Started?</h2>
                        <p className="mb-6">
                            Apply now for quick loans, insurance, or real estate assistance.
                        </p>
                    </div>
                    <PrimaryButton onClick={() => navigate("/contact")} className="bg-white text-blue-600 hover:bg-gray-200">
                        Apply Now
                    </PrimaryButton>
                </div>
            </Container>
        </section>
    );
}
